module.exports = __webpack_public_path__ + "img/5.ed6b84f5.jpg";